import { render, staticRenderFns } from "./HumanResource.vue?vue&type=template&id=1d4036e2&scoped=true&"
import script from "./HumanResource.vue?vue&type=script&lang=js&"
export * from "./HumanResource.vue?vue&type=script&lang=js&"
import style0 from "./HumanResource.vue?vue&type=style&index=0&id=1d4036e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4036e2",
  null
  
)

export default component.exports